import Joi from 'joi'

const messages = {
  description: {
    required: 'Descrição do serviço é obrigatória',
    max: 'Permitido no máximo 60 caracteres'
  },
  serviceListCode: {
    integer: 'Código de lista de serviço deve ser um número inteiro'
  }
}

export const serviceSchema = Joi.object({
  id: Joi.string().uuid({ version: ['uuidv4'] }),
  code: Joi.string().allow(''),
  description: Joi.string().max(60).trim().required().messages({
    'any.required': messages.description.required,
    'string.empty': messages.description.required,
    'string.max': messages.description.max
  }),
  serviceListCode: Joi.number().integer().optional().messages({
    'number.integer': messages.serviceListCode.integer
  })
})
